import PropTypes from 'prop-types';
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  IconButton,
} from '@mui/material';
import { Edit as EditIcon } from '@mui/icons-material';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

SeasonsTable.propTypes = {
  seasons: PropTypes.array.isRequired,
  onEditSeason: PropTypes.func.isRequired,
};

export default function SeasonsTable({ seasons, onEditSeason }) {
  return (
    <TableContainer sx={{ minWidth: 800 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Season Year</TableCell>
            <TableCell>Display Name</TableCell>
            <TableCell align="center">Current Season</TableCell>
            <TableCell align="center">Visible</TableCell>
            <TableCell align="center">Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {seasons.map((season) => (
            <TableRow key={season.seasonId} hover>
              <TableCell>
                {season.seasonYear}
              </TableCell>
              <TableCell>
                {season.displayName}
              </TableCell>
              <TableCell align="center">
              {season.isCurrentSeason ? (
                    <Iconify
                      icon={"eva:checkmark-circle-2-outline"}
                      sx={{ color: "green" }}
                    />
                  ) : (
                    <Iconify
                      icon={"eva:close-circle-outline"}
                      sx={{ color: "red" }}
                    />
                  )}
              </TableCell>
              <TableCell align="center">
              {season.isVisible ? (
                    <Iconify
                      icon={"eva:checkmark-circle-2-outline"}
                      sx={{ color: "green" }}
                    />
                  ) : (
                    <Iconify
                      icon={"eva:close-circle-outline"}
                      sx={{ color: "red" }}
                    />
                  )}
              </TableCell>
              <TableCell align="center">
                <IconButton title="Edit Season"
                  onClick={() => onEditSeason(season)}
                  color="primary"
                >
                  <EditIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          {seasons.length === 0 && (
            <TableRow>
              <TableCell colSpan={5} align="center">
                No seasons found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
